import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    /* Registro */
    bancosMovimientosTipos: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    nombre: '',
    incluirInactivos: false,

    bancosMovimientosTiposSelect: [],
    bancosMovimientosTiposSelectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.bancosMovimientosTipos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR'(state) {
        state.bancosMovimientosTipos = [];
    },
    'SET_BANCOS_MOVIMIENTOS_TIPOS'(state, bancosMovimientosTipos) {
        state.bancosMovimientosTipos = bancosMovimientosTipos;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_BANCOS_MOVIMIENTOS_TIPOS_SELECT'(state) {
        state.bancosMovimientosTiposSelect = [];
        state.bancosMovimientosTiposSelectList = [];
    },
    'SET_BANCOS_MOVIMIENTOS_TIPOS_SELECT'(state, list) {
        state.bancosMovimientosTiposSelect = list;
        state.bancosMovimientosTiposSelectList = list.map(item => item.nombre.trim());
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
    
    getBancosMovimientosTipos: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR')

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            apiAxios.get('bancosmovimientostipos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_BANCOS_MOVIMIENTOS_TIPOS', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)))
            }, error => {
                reject(error);
            })
    },

    getBancosMovimientosTiposSelect: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_BANCOS_MOVIMIENTOS_TIPOS_SELECT');

            apiAxios.get('bancosmovimientostipos/list')
                .then(res => {
                    commit('SET_BANCOS_MOVIMIENTOS_TIPOS_SELECT', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)))
            }, error => {
                reject(error);
            })
    },

};

const getters = {
    getField,

    bancosMovimientosTiposSelect (state) {
        return state.bancosMovimientosTiposSelect;
    },
    bancosMovimientosTiposSelectList (state) {
        return state.bancosMovimientosTiposSelectList;
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}